import React, { useState, useEffect, useRef } from 'react';
import { loadGapiInsideDOM, loadAuth2 } from 'gapi-script';
import { useDispatch } from 'react-redux';
import { changeBscWalletAddress, changeH5Login } from '../../store/module/h5Login';
import google from '@/assets/images/google.png';
import { useNavigate } from 'react-router-dom';
import { Toast } from 'react-vant';
import { useTranslation } from 'react-i18next';



// import { UserCard } from './UserCard';

const timeout = (ms: any) => {
  return new Promise(() => {
    setTimeout(() => {
    }, ms);
  });
};

export const GoogleLogin = ({ type = 1 }: any) => {
  const { t } = useTranslation();
  const [user, setUser] = useState<any>(null);
  const [gapi, setGapi] = useState<any>(null);
  const dispatch = useDispatch()
  useEffect(() => {
    const loadGapi = async () => {
      let toast: any = null
      if (!type) {
        toast = Toast.loading({
          message: t("other.loading"),
          forbidClick: true,
          duration: 0,
        });
      }
      const newGapi = await loadGapiInsideDOM();
      setGapi(newGapi);
      toast && toast.clear()
    }
    loadGapi();
  }, []);

  useEffect(() => {
    if (!gapi) return;
    let toast = Toast.loading({
      message: t("other.loading"),
      forbidClick: true,
      duration: 0,
    });
    const setAuth2 = async () => {
      const auth2 = await loadAuth2(gapi, '454515815971-703q1asa1abdl9dm59n62ciiit1eduvc.apps.googleusercontent.com', '')
      if (auth2.isSignedIn.get()) {
        updateUser(auth2.currentUser.get())
        toast.clear()
      } else {
        attachSignin(document.getElementById('customBtn'), auth2);
        toast.clear()
      }
    }
    
    setAuth2();
  }, [gapi]);

  const updateUser = (currentUser: any) => {

    const name = currentUser.getBasicProfile().getName();
    console.log("🚀 ~ updateUser ~ currentUser:", currentUser)
    const profileImg = currentUser.getBasicProfile().getImageUrl();
    dispatch(changeH5Login({ ...currentUser.wt, ...currentUser.xc, type: 'google' }))
    localStorage.setItem('userId', currentUser.wt.NT)
    localStorage.setItem('userName', currentUser.wt.Ad)
    localStorage.setItem('email', currentUser.wt.cu)
    localStorage.setItem('avatar_url', currentUser.wt.hK)
    localStorage.setItem('id_token', currentUser.xc.id_token)
    setUser({
      name: name,
      profileImg: profileImg,
    });
  };

  const attachSignin = (element: any, auth2: any) => {
    auth2.attachClickHandler(element, {},
      (googleUser: any) => {
        updateUser(googleUser);
      }, (error: any) => {
        console.log(JSON.stringify(error))
      });
  };

  const logoutCancel = () => {
    localStorage.clear()
    sessionStorage.clear()
  }
  const signOut = async () => {
    const auth2 = await gapi.auth2.getAuthInstance();
    logoutCancel()
    dispatch(changeH5Login({}))
    dispatch(changeBscWalletAddress({}))
    await auth2.disconnect()
    window.location.href = import.meta.env.VITE_HREF;

    setUser(null);
  }

  return (
    <>
      {type ?
        <div id="customBtn" className="new_button_shadow flex cursor-pointer relative justify-center gap-[10px] text-[16px] leading-[19px] text-[#fff] font-semibold">
          <img src={google} className='w-5 h-5' alt="" /> {t("h5.google")}
        </div> :
        <div onClick={signOut} className="new_button_shadow flex cursor-pointer relative items-center px-5 gap-5 text-[16px] leading-[19px] text-[#fff] w-[174px] h-[36px] font-semibold btn login">
          {t("h5.signout")}
        </div>}
    </>


  )

}
